import React from "react";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";

interface SkuTableEmptyProps {
  colSpan?: number;
}

export const SkuTableEmpty: React.FC<SkuTableEmptyProps> = ({
  colSpan = 6,
}) => {
  const { translate } = useFlightTranslation();

  return (
    <tr>
      <td
        colSpan={colSpan}
        style={{
          padding: "12px",
          textAlign: "center",
          borderBottom: "1px solid #ddd",
        }}
      >
        {translate("No SKUs found")}
      </td>
    </tr>
  );
};
